/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SettingsUpdatePayloadRequest
 */
export interface SettingsUpdatePayloadRequest {
    /**
     * 
     * @type {number}
     * @memberof SettingsUpdatePayloadRequest
     */
    testTime: number;
}

/**
 * Check if a given object implements the SettingsUpdatePayloadRequest interface.
 */
export function instanceOfSettingsUpdatePayloadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "testTime" in value;

    return isInstance;
}

export function SettingsUpdatePayloadRequestFromJSON(json: any): SettingsUpdatePayloadRequest {
    return SettingsUpdatePayloadRequestFromJSONTyped(json, false);
}

export function SettingsUpdatePayloadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SettingsUpdatePayloadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'testTime': json['test_time'],
    };
}

export function SettingsUpdatePayloadRequestToJSON(value?: SettingsUpdatePayloadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'test_time': value.testTime,
    };
}

